const GUID = '093A49A9-4EF5-4D1D-9BC4-102361C87844'

export { GUID }